import { createKeyMapping, type KeyMapping } from '@/libraries/common/minificationUtils'

/** Maps Fabric.js canvas/object property names to their minified short codes.
 *  Covers: shared object properties, Text/IText, Path, Polygon, Group, and canvas root. */
export const FABRIC_KEY_MAP: Record<string, string> = {
  // Shared object properties
  _id: '_id',
  dimensions: 'd',
  type: 't',
  version: 'v',
  originX: 'ox',
  originY: 'oy',
  left: 'l',
  top: 'x',
  width: 'w',
  height: 'h',
  ry: 'ry',
  rx: 'rx',
  fill: 'fi',
  fillRule: 'fr',
  stroke: 'sk',
  strokeWidth: 'sw',
  strokeDashArray: 'sda',
  strokeLineCap: 'slc',
  strokeLineJoin: 'slj',
  strokeDashOffset: 'sdo',
  strokeMiterLimit: 'sml',
  strokeUniform: 'su',
  opacity: 'op',
  angle: 'a',
  flipX: 'fx',
  flipY: 'fy',
  visible: 'vi',
  scaleX: 'sx',
  scaleY: 'sy',
  skewX: 'kx',
  skewY: 'ky',
  shadow: 'sh',
  paintFirst: 'pf',
  globalCompositeOperation: 'gco',
  backgroundColor: 'bgc',
  // // Circle
  radius: 'r',
  startAngle: 'sa',
  endAngle: 'ea',
  counterClockwise: 'ccw',
  // // Text / IText
  text: 'tx',
  fontFamily: 'ff',
  fontSize: 'fs',
  fontStyle: 'fst',
  fontWeight: 'fw',
  textAlign: 'ta',
  textBackgroundColor: 'tbc',
  lineHeight: 'lh',
  charSpacing: 'cs',
  direction: 'dir',
  path: 'p',
  pathStartOffset: 'pso',
  pathSide: 'psi',
  pathAlign: 'pal',
  underline: 'ul',
  overline: 'ov',
  linethrough: 'lt',
  minWidth: 'mw',
  splitByGrapheme: 'sbg',
  textDecorationThickness: 'tdt',
  styles: 'st',
  // // Path / Polygon
  points: 'pts',
  // // Group + canvas root
  objects: 'o',
  background: 'bg',
}

export const FABRIC_KEY_MAPPING: KeyMapping = createKeyMapping(FABRIC_KEY_MAP)
